export default __webpack_public_path__ + "static/media/camera-icon.78c91951.svg";